module.exports = __webpack_public_path__ + "media/images/bank_images/banrisul-2d62962be1e29bf1b8dcf0d3bbe78743.png";